/**
 * Route-level error boundary.
 *
 * `createBrowserRouter` catches render errors before the app-level <ErrorBoundary> in App.tsx can
 * see them, so without this the user gets React Router's built-in developer screen — a raw stack
 * trace and a "Hey developer" note. Wiring it as the root route's `errorElement` puts the console's
 * own recovery UI back in front of the user for any route that throws.
 */

import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import ErrorFallback from "@/components/ErrorFallback";

export function RouteErrorBoundary() {
  const routeError = useRouteError();

  const error =
    routeError instanceof Error
      ? routeError
      : isRouteErrorResponse(routeError)
        ? new Error(`${routeError.status} ${routeError.statusText}`)
        : new Error(String(routeError ?? "Unknown routing error"));

  // No onReset: the router keeps the failed match, so a full reload is the only reliable recovery.
  return <ErrorFallback error={error} />;
}
